import styled from 'styled-components';
import { Text } from '~/components/ui/Text';
import { AppAdsPlayerAvatarSize } from './AppAdsPlayerAvatar.model';

const StyledPlayerAvatar = styled.div<{ $size: AppAdsPlayerAvatarSize }>`
	display: flex;
	align-items: center;
	justify-content: center;
	width: ${(props) => props.$size}px;
	min-width: ${(props) => props.$size}px;
	height: ${(props) => props.$size}px;
	border-radius: ${(props) =>
		props.$size === AppAdsPlayerAvatarSize.Small ? 6 : 10}px;

	${Text} {
		font-weight: 500;
		font-size: 14px;
		color: #ffffff;
	}
`;

export { StyledPlayerAvatar };
